import {tools as sukoaUtils} from "../tools.js";

export default class SearchResults {
    constructor(searchResultsEl) {
        this.searchResultsEl = searchResultsEl
        this.noResultsEl = searchResultsEl.querySelector('#search_no_results');
        this.spinnerEl = searchResultsEl.querySelector('#search_spinner');
        this.sectionsEl = searchResultsEl.querySelectorAll('section')
        this.tabListEl = searchResultsEl.querySelector('ul.tab-list')
        this.textGroupEl = searchResultsEl.querySelectorAll('.search-list-item-text-group');

        // URL
        this.URL = new URL(sukoaUtils.getCurrentURL());
        this.activeTab = this.URL.searchParams.get('tab') || '';
        this.searchQuery = this.URL.searchParams.get('q') || '';

        if (this.tabListEl) {
            this.createTabs()
            this.tabsEl = this.tabListEl.querySelectorAll('.tab-list-item')
            this.initInitialTabFromURL()
            this.initEventListeners()
        }

        this.noResultsEl && this.renderNoResults()
    }

    createTabs() {
        let totalSize = 0;

        if (this.tabListEl) {
            const enabledTabs = [];
            const disabledTabs = [];

            // Create tabs from content sections
            this.sectionsEl.forEach(section => {
                const id = section.id
                if (!id) return

                // Remove dots (thousand separator) before parsing since it will be interpreted as decimal point
                const sizeInt = parseInt((section.dataset.size).replace(/\./g, ''), 10);
                totalSize += sizeInt

                const li = document.createElement('li')
                li.classList.add('tab-list-item')
                li.dataset.refId = id

                const button = document.createElement('button')
                const sizeFormatted = new Intl.NumberFormat('de-CH').format(sizeInt);
                button.textContent = `${section.dataset.title} (${sizeFormatted})`

                // Disable tab if no results
                if (!sizeInt) {
                    li.classList.add('disabled')
                    button.setAttribute('disabled', 'true')
                    disabledTabs.push(li);
                } else {
                    enabledTabs.push(li);
                }

                li.appendChild(button)
            })

            // Append all enabled tabs first -> then disabled tabs
            enabledTabs.forEach(li => this.tabListEl.append(li));
            disabledTabs.forEach(li => this.tabListEl.append(li));

            // Create default tab "All"
            const defaultTab = document.createElement('li');
            defaultTab.classList.add('tab-list-item')

            const allButton = document.createElement('button')
            const totalSizeFormatted = new Intl.NumberFormat('de-CH').format(totalSize);
            allButton.textContent = `Alle (${totalSizeFormatted})`

            defaultTab.appendChild(allButton)
            this.tabListEl.insertBefore(defaultTab, this.tabListEl.firstChild)
        }
    }

    handleTabChange(refId) {
        const tab = this.tabListEl.querySelector(`[data-ref-id="${refId}"]`) ?? this.tabListEl.firstElementChild;

        // Update URL with tab param
        if(!!tab.dataset.refId) {
            this.URL.searchParams.set('tab', encodeURIComponent(tab.dataset.refId))
        } else {
            this.URL.searchParams.delete('tab')
        }

        // Update "active" state for css
        this.tabsEl.forEach(t => t.classList.remove('active'))
        tab?.classList.add('active')

        // Redirect
        window.location.href = this.URL.toString()
    }

    initEventListeners() {
        // Handle click on nav tabs
        this.tabsEl.forEach(tab => {
            tab.addEventListener('click', () => {
                this.handleTabChange(tab.dataset.refId)
            })
        })
        // Handle click to tab in section
        this.sectionsEl.forEach(section => {
            section.querySelector('.show-in-tab-btn')?.addEventListener('click', () => {
                this.handleTabChange(section.id)
            })
        })

        // Handle infinite scroll on active tab
        if (this.activeTab) {
            this.activeTabEl = document.querySelector(`section#${this.activeTab}`);

            this.buffer = 500
            this.isFetching = false
            this.page = 2
            this.hasMore = this.activeTabEl.dataset.hasmore === 'true'

            window.addEventListener('scroll', () => {
                this.handleInfiniteScroll()
            });
        }
    }

    handleInfiniteScroll() {
        const scrollThresholdReached = window.innerHeight + window.scrollY >= document.body.offsetHeight - this.buffer

        if (!this.isFetching && this.hasMore && scrollThresholdReached) {
            this.isFetching = true
            this.spinnerEl.classList.remove('hide')

            sukoaUtils.ajxGet(`${this.URL.pathname}${this.URL.search}&page=${this.page}`, {
                fallback: (doc) => {
                    const newSection = doc.querySelector(`#${this.activeTab}`);

                    if (newSection && this.activeTabEl) {
                        const newItems = newSection.querySelectorAll('.search-list li');
                        newItems.forEach(item => {
                            this.activeTabEl.querySelector('.search-list')?.appendChild(item);
                        });

                        this.hasMore = newSection.dataset.hasmore === 'true';
                    }

                    this.page++;
                    this.isFetching = false;
                    this.spinnerEl.classList.add('hide');

                    // Show text if no more results
                    if (!this.hasMore) {
                        const noMoreResultsEl = document.createElement('p');
                        noMoreResultsEl.textContent = "Keine weiteren Ergebnisse";
                        noMoreResultsEl.id = "search_no_more_results";
                        this.activeTabEl.appendChild(noMoreResultsEl);
                    }
                }
            });
        }
    }

    initInitialTabFromURL() {
        let targetTab = this.tabsEl[0];

        if (this.activeTab) {
            // Find the tab element of the associated url param
            const associatedTab = [...this.tabsEl].find(t => t.dataset.refId === decodeURIComponent(this.activeTab))
            if (associatedTab && !associatedTab.classList.contains("disabled")) {
                targetTab = associatedTab
            }
        }

        this.tabsEl.forEach(t => t.classList.remove('active'))
        targetTab?.classList.add('active')
    }

    renderNoResults() {
        let totalSize = 0
        this.sectionsEl.forEach(section => {
            const size = section.dataset.size || '0'
            const sizeInt = parseInt(size.replace(/\./g, ''), 10)
            totalSize += sizeInt
        });

        if (totalSize === 0) {
            const message = document.createElement("p")
            message.textContent = "Keine Ergebnisse gefunden"
            this.noResultsEl.appendChild(message)
            this.noResultsEl.classList.remove('hide')
        }
    }
}